import { useState, useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { pb } from '@/lib/pocketbase';

export const useTutorChatNotifications = () => {
  const { user } = useAuth();
  const [unreadChatCount, setUnreadChatCount] = useState(0);
  const [tutorProfile, setTutorProfile] = useState<any>(null);

  // Get tutor profile
  useEffect(() => {
    const fetchTutorProfile = async () => {
      if (!user?.id || user.role !== 'tutor') return;
      
      try {
        const profile = await pb.collection('tutors').getFirstListItem(`user = "${user.id}"`);
        setTutorProfile(profile);
      } catch (error) {
        console.error('Error fetching tutor profile for chat notifications:', error);
      }
    };

    fetchTutorProfile();
  }, [user?.id, user?.role]);

  // Fetch unread chat count
  const fetchUnreadChatCount = async () => {
    if (!tutorProfile?.id) return;
    
    try {
      const unreadMessages = await pb.collection('tutor_student_messages').getList(1, 1, {
        filter: `tutorId = "${tutorProfile.id}" && isRead = false && fromTutor = false`
      });
      
      setUnreadChatCount(unreadMessages.totalItems);
    } catch (error) {
      console.error('Error fetching unread chat count:', error);
      setUnreadChatCount(0);
    }
  };

  // Initial fetch and real-time subscription
  useEffect(() => {
    if (!tutorProfile?.id) return;

    // Initial fetch
    fetchUnreadChatCount();

    // Set up real-time subscription
    const subscription = pb.collection('tutor_student_messages').subscribe('*', (e) => {
      console.log('Chat message event:', e);
      
      // Only refresh count if it's for this tutor
      if (e.record?.tutorId === tutorProfile.id) {
        fetchUnreadChatCount();
      }
    });

    return () => {
      subscription.then(unsub => unsub()).catch(console.error);
    };
  }, [tutorProfile?.id]);

  return { unreadChatCount };
};